module.exports = __webpack_public_path__ + "static/media/GMatch_NEW_WHITE.ff1fd14b.png";